import { CustomLink } from "@/types";

export const getLink = (customLink: CustomLink | string, locale: string): string | { href: string; query: string } => {
  if (typeof customLink === "string") return `/${locale}/${customLink}`;
  try {
    const { link } = customLink;
    switch (link.linkType) {
      case "content":
        switch (link?.content?.type) {
          case "pageProject":
            return `/${locale}/projects/${link?.content?.slug}`;
          case "pageCommunity":
            return `/${locale}/communities/${link?.content?.slug}`;
          case "pageEditorial":
            return `/${locale}/${link?.content?.slug}`;
          case "article":
            return `/${locale}/d-hub/${link?.content?.params?.articleType}/${link?.content?.slug}`;
          case "unit":
            return `/${locale}/units/${link?.content?.slug}`;
          default:
            return `/${locale}/${link?.content?.slug}`;
        }
      case "search":
        let queryString = link?.url?.trim()?.split("?")[1] || link?.url?.trim()?.replace("?", "");
        return {
          href: `/${locale}/search/`,
          query: `${queryString}`,
        };
      default:
        return link?.url?.startsWith("/") ? `/${locale}${link.url}` : link.url;
    }
  } catch (error) {
    console.error(JSON.stringify(customLink), error);
    return `#`;
  }
};
